import Route from '@ember/routing/route';

import { set } from '@ember/object';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — product detail page (`/detail/:id`): passes the dynamic segment
 *              through as the model, resets all prior selection state, and kicks the
 *              controller's private-availability and product-existence-check tasks.
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     params (raw dynamic-segment object, e.g. `{ id }`)
 *   key:       setupController, resetController
 *   uses:      application controller (collapses cart/menu chrome)
 *   siblings:  controllers/detail.js (owns loadPrivateTask/checkAvailabilityTask this
 *              route starts on entry and cancels on leave)
 *   tests:     simple-routes-test.js ("detail route resets the whole product-detail
 *              selection state", "detail route starts both load tasks and cancels them
 *              on leave", "detail route model passes the dynamic segment straight
 *              through"), detail-routes-test.js
 *   gotchas:   -
 *
 * Per-visit reset + task kickoff for the product detail page.
 */
export default class DetailRoute extends Route {
  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    set(controller, 'buyGroups', null);
    set(controller, 'buyMaestro', null);
    set(controller, 'privateData', null);
    set(controller, 'searchBy', null);
    set(controller, 'oreSelected', []);
    set(controller, 'oreSelectedDate', []);
    set(controller, 'language', null);
    set(controller, 'gender', null);
    set(controller, 'byGroupComp', null);

    controller.setProperties({
      id: model.id,
    });
    controller.loadPrivateTask.perform();
    controller.checkAvailabilityTask.perform();
  }

  resetController(controller) {
    controller.loadPrivateTask.cancelAll();
    controller.checkAvailabilityTask.cancelAll();
  }
}
